export const TVPlans = [
  { id: 1, title: "Your Fios TV", price: 65 },
  { id: 2, title: "More Fios TV", price: 85 },
  { id: 3, title: "The Most Fios TV", price: 105 }
];